import { getTranslationObject } from "./translations/compoundTranslationMapper";

const translationObj = {
    pl: getTranslationObject("pl"),
    en: getTranslationObject("en"),
    de: getTranslationObject("de"),
    fr: getTranslationObject("fr")
};

/**
 * 
 * @param {string} key 
 * @param {string} lang 
 */
export const getTranslationLang = (key, lang = "pl") => {
    if (!lang || !key) return null;
    const langObj = translationObj[lang];
    if (!langObj) return key;
    let compoundKeyMatch = /([A-Za-z_]+)\{([0-9]+)\}/g.exec(key);
    return compoundKeyMatch ? getTranslationFromCompoundKey(compoundKeyMatch, langObj, key) : (langObj[key] || key);

}
function getTranslationFromCompoundKey(match, langObj, key) {
    let parsedKey = match[1];
    let index = match[2];
    let translation = langObj[parsedKey];
    return translation ? resolveTranslationContent(translation, index) : key;
}

/**
 * {1:translationA}{2: translationB}...{index:desired translation value}
 * @param {string} str whole translation value
 * @param {number} index index
 */
const resolveTranslationContent = (str, index) => {
    let regex = new RegExp(`\\{${index}:([^}]+)}`);
    let match = regex.exec(str);
    if(!match) return str;
    return match[1];

}

let currentLang;
if (window.location.search) {
    const queryString = window.location.search.substring(1);
    const variables = queryString.split('&');
    for (const variable of variables) {
      const pair = variable.split('=');
      if (pair[0] === 'lang') {
          currentLang = pair[1];
      }
    }
} else if (localStorage.getItem('lang')) {
    currentLang = localStorage.getItem('lang');
} else {
    currentLang = "pl";
}

export const getTranslation = (key) => (getTranslationLang(key, currentLang));
export const setLanguage = (newLang) => {
    currentLang = newLang;
    localStorage.setItem('lang', newLang);
}
export const getAvailableLanguages = () => Object.keys(translationObj);
export const translationsAreAvailableForLang = (lang) => {
    // getAvailableLanguages().find(k => k === lang) !== -1
    const langs = getAvailableLanguages();
    for(let i=0;i<langs.length;i++){
        if(langs[i] === lang) return true;
    }
    return false;
};
export const getCurrentLang = () => {
    if (window.location.search) {
      const queryString = window.location.search.substring(1);
      const variables = queryString.split('&');
      for (const variable of variables) {
        const pair = variable.split('=');
        if (pair[0] === 'lang') {
            return pair[1];
        }
      }
    } else if (localStorage.getItem('lang')) {
        return localStorage.getItem('lang');
    } else {
        return currentLang;
    }
};
export function getCurrentLangFullName() {
    let langList = ['Polski', 'English', 'Deutsch', 'Français'];
    if (getCurrentLang() === 'pl') return langList[0]; 
    else if (getCurrentLang() === 'en') return langList[1];
    else if (getCurrentLang() ==='de') return langList[2];
    else if (getCurrentLang() === 'fr') return langList[3];
    else return langList[0];
}

const getBrowserLang = () => {
    return (navigator.languages) ||
        navigator.language ||
        navigator.userLanguage
}

const trySetLanguage = (lang) => {
    if (lang.length < 2) return false;
    const code = lang.slice(0, 2);
    if (translationsAreAvailableForLang(code)) {
        setLanguage(code);
        return true;
    }
    return false;
}

export const setLangByShopId = (shoplangId) => {
    const langs={
        "1":"pl",
        "2":"en",
        "3":"de",
        "5":"fr",
        "12":"es"
    }
    if(!shoplangId || !langs[shoplangId]) throw new Error("invalid langId");
    trySetLanguage(langs[shoplangId]);
}

export const SetLanguageDependingOnBrowserSettings = () => {
    const detect = getBrowserLang();
    //undetected => polish by default, do nothing
    if (!detect) return;
    if (typeof detect === "string") {
        trySetLanguage(detect)
    } else if (Array.isArray(detect)) {
        detect.find(item => trySetLanguage(item));
    }
}


// WEBPACK FOOTER //
// ./src/assets/creator/translations.js